import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useAdaptiveTextColor, useCompContext, useCompFormContext } from '@/context/__project__/CompContext'

import { CompHiddenFieldWrapperCore } from '../core/forms/hidden-field/wrapper'
import { CompHiddenField } from './CompHiddenField'

/**
 * CompHiddenFieldWrapper
 */
const CompHiddenFieldWrapper = () => {
  // infos
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const { currentParentBg } = useAdaptiveTextColor()
  const infosProps = { ...compContext, currentParentBg, activeLayer }

  // form
  const formContext = useCompFormContext()

  return (
    <CompHiddenFieldWrapperCore infos={infosProps} form={formContext} isPreview={window.appMode === 'preview'}>
      {(props) => <CompHiddenField {...props} />}
    </CompHiddenFieldWrapperCore>
  )
}


export default CompHiddenFieldWrapper